<template>
  <div class="wrapper">
    <Header></Header>
    <a class="guanggao" :href="dingbu1['dirlink']">
      <img :src="dingbu1['logo']" alt>
    </a>

    <div class="content-wrap">
      <div class="content-left">
        <div class="seat">
          <span>当前位置：</span>
          <router-link to="/">首页></router-link>
          <span class="coord">网站介绍</span>
        </div>

        <div class="news-content">
          <!--<span class="title">山东消费网简介</span>-->
          <!--<div class="from">-->
          <!--<span v-text="'来自: 山东消费网'"></span>-->
          <!--<span v-text="'作者:'"></span>-->
          <!--<span v-text="'发布时间: 2014-04-28'"></span>-->
          <!--</div>-->

          <div class="text" v-html="webMsg">
            山东省青岛市即墨区因服装批发远近闻名，
            拥有小商品城、服装批发市场、布匹床上用品批发市场等多个批发市场
            。这些市场大多历史悠久、规模大、摊位多，市场监管的压力较大。
            近日，《中国消费者报》记者从即墨区市场监督管理局了解到，
            该局为能更精细地进行市场监管，探索推行了“街长制”，
            发动商户自愿参与市场治理，打造出社会共治、市场共建、环境共享的市场监管新格局。
          </div>
        </div>
        <div style="margin-top:20px;">
          分享到:
          <share :config="shareConfig"></share>
        </div>
      </div>

      <div class="content-right">
        <div>
          <NewsModule title="最新" :more="false" :active="false" :info="rightNews.new"></NewsModule>
        </div>
        <div>
          <NewsModule title="热点推荐" :more="false" :active="false" :info="rightNews.top"></NewsModule>
        </div>

        <a :href="art2.dirlink" v-if="art2.type&&art2.type===1">
          <object data type>
            <embed style="width:380px;height:100px;" :src="art2.logo" type>
          </object>
        </a>

        <a class="guanggao2" :href="art2.dirlink" v-else>
          <img style="width:380px;height:100px;" :src="art2.logo" alt>
        </a>

        <a class="guanggao2" :href="art3.dirlink" v-if="art3.type&&art3.type===1">
          <object data type>
            <embed style="width:380px;height:100px;" :src="art3.logo" type>
          </object>
        </a>
        <a class="guanggao2" :href="art3.dirlink" v-else>
          <img style="width:380px;height:100px;" :src="art3.logo" alt>
        </a>
      </div>
    </div>

    <HomeFoot></HomeFoot>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import HomeFoot from "@/components/HomeFoot.vue";
import NewsList from "@/components/NewsList.vue";
import NewsModule from "@/components/NewsModule.vue";

export default {
  name: "article",
  components: {
    Header,
    HomeFoot,
    NewsList,
    NewsModule
  },
  data() {
    return {
      id: "",
      complainMessage: "",
      rightNews: "",
      newsContent: "",
      commentContent: "",
      commentMsg: [],
      morePinglun: "",
      count: "",
      commentPage: 1,
      dingbu1: "",
      art2: "",
      art3: "",
      totalPage: "",
      webMsg: "",
      shareConfig: {
        // url: '', // 网址，默认使用 window.location.href
        // source: '', // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
        // title: '', // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
        // description: '', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
        // image: '', // 图片, 默认取网页中第一个img标签
        sites: ["wechat", "qzone", "qq", "weibo"], // 启用的站点
        // disabled: ['google', 'facebook', 'twitter'], // 禁用的站点
        wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
        wechatQrcodeHelper:
          "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>"
      }
    };
  },
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      this.getNewsContent();
    }
  },
  created() {
    this.getNewsContent();
    this.getRightNews();
    this.getGuangGao();
    this.getArticle();
    // 每次刷新页面都跳转到页面顶部
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  methods: {
    // 网站介绍
    getArticle() {
      this.$get("/api/general/about_site")
        .then(res => {
          if (res.code === 0) {
            this.webMsg = res.data;
            // console.log(this.webMsg, '网站介绍')
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getGuangGao() {
      this.$get("https://315sd.0532.name/api/general/new_hot")
        .then(res => {
          if (res.code === 0) {
            this.dingbu1 = res.data.ad1;
            this.art2 = res.data.ad2;
            this.art3 = res.data.ad3;
            // console.log(res.data, '广告看一下吧')
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getNewsContent() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;

      // 获取首页跳转时携带的分类id
      this.id = this.$route.query.id;
      this.$post("https://315sd.0532.name/api/general/article_detail", {
        id: this.id
      })
        .then(res => {
          if (res.code === 0) {
            this.newsContent = res.data;
            this.readComment();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getRightNews() {
      // 获取首页跳转时携带的分类id
      this.id = this.$route.query.id;
      this.$get("https://315sd.0532.name/api/general/new_hot")
        .then(res => {
          if (res.code === 0) {
            this.rightNews = res.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    //获取评论
    readComment() {
      this.$post("https://315sd.0532.name/index/comment/a_comment_list", {
        id: this.id, //文章ID
        page: this.commentPage
      })
        .then(res => {
          if (res.code === 0) {
            this.totalPage = res.data;
            this.count = res.data.count;
            this.commentMsg = res.data.listData;
            // console.log(this.commentMsg, '获取到的评论');
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取更多评论
    moreComment() {
      this.commentPage += 1;
      if (this.commentPage > this.totalPage) {
        this.$message("没有更多评论了");
      } else {
        this.$post("https://315sd.0532.name/index/comment/a_comment_list", {
          id: this.id,
          page: this.commentPage
        })
          .then(res => {
            if (res.code === 0) {
              this.morePinglun = res.data.listData;
              if (!this.morePinglun[0]) {
                this.$message("没有更多评论了");
              } else {
                this.commentMsg.push.apply(this.commentMsg, this.morePinglun);
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },

    // 提交评论
    submit() {
      let token = localStorage.getItem("token");
      if (this.commentContent) {
        this.$post("https://315sd.0532.name/index/comment/apost_comment", {
          token: token,
          id: this.id,
          detail: this.commentContent
        })
          .then(res => {
            if (res.code === 0) {
              this.$message({
                message: res.msg,
                type: "success"
              });
              this.commentContent = "";
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.$message({
          message: "请输入评论",
          type: "warning"
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
.content-wrap {
  display: flex;
  width: 1200px;
  margin: 32px auto;
  justify-content: space-between;
}

.guanggao {
  display: block;
  width: 1200px;
  height: 100px;
  margin: 0 auto;
  margin-top: 20px;

  img {
    width: 1200px;
    height: 100px;
  }
}

.guanggao2 {
  width: 380px;
  height: 100px;
  margin: 10px 0;

  img {
    width: 380px;
    height: 100px;
  }
}

.top {
  width: 27px;
  height: 13px;
  background: #d60106;
  font-size: 8px;
  font-family: MicrosoftYaHei;
  color: rgba(255, 255, 255, 1);
  line-height: 10px;
  padding: 1px 2px;
  margin-left: 3px;
}

.coord {
  color: #000000;
  cursor: default;
}

.content-left {
  width: 780px;

  .seat {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: rgba(102, 102, 102, 1);
    line-height: 20px;
    margin-bottom: 40px;

    .seat > span {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: rgba(153, 153, 153, 1);
      line-height: 20px;
    }
  }
}

.title {
  font-size: 44px;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: #666666;
  line-height: 59px;
}

.from {
  height: 21px;
  font-size: 17px;
  font-family: MicrosoftYaHei;
  color: rgba(102, 102, 102, 1);
  line-height: 21px;
  margin-bottom: 50px;
  margin-top: 15px;
}

.from > span {
  margin-left: 40px;
}

.from > span:first-child {
  margin-left: 0;
}

.text {
  width: 780px;
  min-height: 810px;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}

.text > img {
  max-width: 100%;
}

.content-foot {
  display: flex;
  justify-content: space-between;
  width: 787px;
  margin-top: 46px;
}

.comment-wrap {
  width: 787px;
}

.comment-wrap > hr {
  margin-top: 30px;
  border: 0;
  height: 1px;
  background: #d8d8d8;
}

.input-wrap {
  width: 787px;
  display: flex;
}

.comment {
  width: 647px;
  height: 48px;
  outline: none;
  -webkit-appearance: none;
  border-radius: 0;
  border: 1px solid #979797;
  line-height: 48px;
  font-size: 16px;
  border-right: none;
  padding-left: 8px;
}

.releace {
  width: 140px;
  height: 52px;
  background: #294b7f;
  outline: none;
  font-size: 18px;
  font-family: MicrosoftYaHei;
  color: #fff;
  line-height: 52px;
  cursor: pointer;
}

.content-right {
  margin-top: 60px;
  margin-left: 60px;
}

.content-right > div {
  margin-bottom: 20px;
}

.comment-area {
  width: 787px;
  height: 79px;
  margin-top: 19px;
}

.comment-area > hr {
  border: 0;
  height: 1px;
  background: #d8d8d8;
}

.comment-number {
  color: #a8a8a8;
}

.number {
  height: 29px;
  font-size: 22px;
  font-family: MicrosoftYaHei;
  color: rgba(208, 2, 27, 1);
  line-height: 29px;
}

.comment-title {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: #6b6b6b;
  line-height: 21px;
}

.comment-info {
  margin: 16px 0;
  font-size: 18px;
  font-family: MicrosoftYaHei;
  color: #333333;
  line-height: 21px;
}

.more-comment {
  width: 95px;
  height: 30px;
  background: #f3f3f3;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: rgba(102, 102, 102, 1);
  line-height: 30px;
  text-align: center;
  margin-left: 332px;
  margin-top: 30px;
  cursor: pointer;
}
</style>

